(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-ec-category-nav]').forEach((section) => {
      if (section.dataset.ecCategoryReady === 'true') return;

      const viewport = section.querySelector('[data-ec-category-viewport]');
      const items = [...section.querySelectorAll('[data-ec-category-item]')];
      const current = section.querySelector('[data-ec-category-current]');
      const previous = section.querySelector('[data-ec-category-prev]');
      const next = section.querySelector('[data-ec-category-next]');
      if (!viewport || items.length < 2 || !current || !previous || !next) return;

      section.dataset.ecCategoryReady = 'true';
      let activeIndex = 0;
      let frame = null;

      const setIndex = (index, scroll = false) => {
        activeIndex = Math.max(0, Math.min(items.length - 1, index));
        current.textContent = String(activeIndex + 1);
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === items.length - 1;
        if (scroll) items[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      };

      const syncFromScroll = () => {
        frame = null;
        const viewportLeft = viewport.getBoundingClientRect().left;
        const nearest = items.reduce((best, item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - viewportLeft);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Number.POSITIVE_INFINITY });
        setIndex(nearest.index);
      };

      viewport.addEventListener('scroll', () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(syncFromScroll);
      }, { passive: true });
      previous.addEventListener('click', () => setIndex(activeIndex - 1, true));
      next.addEventListener('click', () => setIndex(activeIndex + 1, true));
      setIndex(0);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
